import React from "react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Horas"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Seg"
  }];
  const box = tone === "dark" ? "bg-white/10 text-white" : "bg-card text-ink border border-line";
  const label = tone === "dark" ? "text-white/70" : "text-muted";
  const sep = tone === "dark" ? "text-white/50" : "text-muted";
  return <div className="flex items-start justify-center gap-1.5 md:gap-3" role="timer" aria-live="off" data-id="element-73" data-mp="324hvuhu1aogu">
      {units.map((u, i) => <React.Fragment key={u.label} data-id="element-74" data-mp="373b866xl49ff" data-mpi={i}>
          {i > 0 && <span className={`pt-2 text-xl font-bold md:pt-3 md:text-2xl ${sep}`} data-id="element-75" data-mp="10clayhlz829e">:</span>}
          <div className="flex flex-col items-center" data-id="element-76" data-mp="15bfz7z2pqj0w">
            <span className={`w-14 rounded-lg py-2 text-center text-2xl font-extrabold tabular-nums md:w-20 md:rounded-xl md:py-3 md:text-4xl ${box}`} data-id="element-77" data-mp="15awker8d0ar3">
              {String(u.value).padStart(2, "0")}
            </span>
            <span className={`mt-1 text-[10px] font-semibold uppercase tracking-wide md:text-xs ${label}`} data-id="element-78" data-mp="szzcd8s3r2iz">{u.label}</span>
          </div>
        </React.Fragment>)}
    </div>;
}